/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { HousePlanEstimateCreateDialogComponent } from './house-plan-estimate-create-dialog.component';

export const housePlanEstimateCreateDialogRoute = createDialogRoute({
  component: HousePlanEstimateCreateDialogComponent,
});
